import { useFormik } from 'formik';
import { useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { GetDynamicFormByID } from '../../../../store/NTX/FlexValue/Form/formSlice';
import { DynamicFormExtraInfoSchema } from '../../../ValidationForm/validationSchema';
import { UodateDynamicForm } from '../../../../store/NTX/FlexValue/Form/formSlice';
import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
import Select from 'react-select';
import useGetExtraInformationTablesForm from '../../../../hooks/Forms/useGetExtraInformationTablesForm';
import useGetTablesForm from '../../../../hooks/Forms/use-get-tables-form';
import Loading from '../../../../components/Shared/Loader/Loading';

const EditExtraInformationForm = ({ id }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { dataExtraInformationTablesFormList } = useGetExtraInformationTablesForm();

  const { dataTablesFormList } = useGetTablesForm();

  useEffect(() => {
    dispatch(GetDynamicFormByID(id));
  }, [dispatch, id]);
  const { DynamicFormListByID, loading2 } = useSelector((state) => state.Forms);

  const formik = useFormik({
    initialValues: {
      name2: DynamicFormListByID ? DynamicFormListByID.name2 : '',
      name: DynamicFormListByID ? DynamicFormListByID.name : '',
      icon: null,
      moduleId: DynamicFormListByID ? DynamicFormListByID.moduleId : '',
      dynamicFormTypesId: 2, // 2 Extra Information
      isStatic: false,
      tableId: DynamicFormListByID ? DynamicFormListByID.tableId : '',
    },
    enableReinitialize: true,
    validationSchema: DynamicFormExtraInfoSchema(t),
    onSubmit: (values, { resetForm }) => {
      dispatch(
        UodateDynamicForm({
          id: DynamicFormListByID?.id,
          name: values.name,
          name2: values.name2,
          icon: values.icon,
          dynamicFormTypesId: values.dynamicFormTypesId,
          isStatic: values.isStatic,
          tableId: values.tableId,
        })
      )
        .unwrap()
        .then(() => {
          resetForm();
          CustomAlert({ action: 'Edit' });
        })
        .catch((error) => {
          CustomAlert({ action: 'Error' });
        })
        .finally(() => formik.setSubmitting(false));
    },
  });

  return (
    <>
      <Loading loading={loading2} Type="Dots">
        <Form onSubmit={formik.handleSubmit}>
          <div className="row">
            <div className="col-xl-6">
              <div className="form-group mb-3">
                <label className="form-label">{t('LocalName')}</label>
                <Form.Control
                  className="form-control"
                  type="text"
                  autoComplete="off"
                  name="name2"
                  onChange={formik.handleChange}
                  value={formik.values.name2 || ''}
                  isInvalid={!!formik.errors.name2}
                />
                <Form.Control.Feedback type="invalid">{formik.errors.name}</Form.Control.Feedback>
              </div>
            </div>

            <div className="col-xl-6">
              <div className="form-group mb-3">
                <label className="form-label">{t('GlobalName')}</label>
                <Form.Control
                  className="form-control"
                  type="text"
                  autoComplete="off"
                  name="name"
                  onChange={formik.handleChange}
                  value={formik.values.name || ''}
                  isInvalid={!!formik.errors.name}
                />
                <Form.Control.Feedback type="invalid">{formik.errors.name}</Form.Control.Feedback>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xl-12">
              <div className="form-group mb-3">
                <label className="form-label"> {t('Tables')}</label>

                <Select
                  classNamePrefix="react-select"
                  isRtl
                  // classNamePrefix="select"
                  isSearchable={true}
                  options={dataExtraInformationTablesFormList}
                  onChange={(option) => formik.setFieldValue('tableId', option.value)}
                  // placeholder={i18n.language === "ar" ? "إختر" : "Choose"}
                  value={
                    dataTablesFormList?.filter((f) => f.value === DynamicFormListByID?.tableId)[0]
                  }
                  isDisabled
                />
              </div>
            </div>
          </div>

          <hr />

          <div className="d-flex gap-2">
            <button
              disabled={formik.isSubmitting}
              type="submit"
              className="btn btn-lg btn-theme w-100">
              {formik.isSubmitting ? (
                <div className="spinner-border spinner-border-sm me-2"></div>
              ) : (
                <i className="fa fa-save fa-fw me-1"></i>
              )}
              {t('Save')}
            </button>

            <button
              type="button"
              className="btn btn-lg btn-default w-100"
              data-bs-dismiss="modal"
              id="closeModalForm">
              <i className="fa fa-power-off fa-fw me-1"></i> {t('Cancel')}
            </button>
          </div>
        </Form>
      </Loading>
    </>
  );
};

export default EditExtraInformationForm;
